import { Injectable } from '@angular/core'
import { PlayCountApi } from './base'

@Injectable()
export class StaticContentPlayCountApi extends PlayCountApi{
  apiPath(resourceId: number, areaId = '') {
    return `static_contents/${resourceId}/play_counts/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-count/static-content.ts